import { useAuth } from "Shared/Hooks";

export interface UserDropdownModel {
    key: string;
    text?: string;
    href?: string;
    onClick?: () => void;
}
export const useUserDropDownItems = (): UserDropdownModel[] => {
    const { logout } = useAuth();

    // To do: update contact and identity link after apps are ready
    return [
        {
            key: "divider_1"
        },
        {
            key: "privacy",
            text: "Privacy Notice",
            href: "https://aka.ms/DPN"
        },
        {
            key: "divider_2"
        },
        {
            key: "logout",
            text: "Sign out",
            onClick: logout
        }
    ];
};
